import './style.scss';
import AppPreviewImg from "../../../../assets/images/app-preview.webp";
import PlayStoreLogo from "../../../../assets/images/play-store-logo.png";
import AppleAppStoreLogo from "../../../../assets/images/apple-app-store-logo.png";
import { FormEvent, useContext, useState } from 'react';
import SnackbarContext from '../../../../context/snackbar.context';

const MobileAppSectionPSP: React.FC = () => { 
  const snackbarCtx = useContext(SnackbarContext);
  const [number, setNumber] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setNumber(e.target.value);
  };

  const validateMobileNumber = (phoneNo: string): boolean => {
    const phoneNoPattern = /^\d{10}$/;
    return phoneNoPattern.test(phoneNo);
  };

  const handleSendSms = async (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      
      const payload = {
          phone: number,
          template: "send_app_link"
      };
      
    if (!validateMobileNumber(number)) {
        snackbarCtx.toggleSnackbar({
          message: "Please enter a valid 10-digit mobile number!",
          type: "FAILURE",
          visible: true,
        });
        return;
      }

      try {
          const response = await fetch('https://api.cordeliacruises.com/api/v2/sms/send_message', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(payload)
          });
          if (!response.ok) {
            snackbarCtx.toggleSnackbar({
              message: "Failed to send message!",
              type: "FAILURE",
              visible: true,
            });
          } else {
            snackbarCtx.toggleSnackbar({
              message: "App link sent to your mobile!",
              type: "SUCCESS",
              visible: true,
            });
            setNumber('');
          }
      } catch (error) {
          console.log(error);
      }
  };
  
    return (
      <>
        <div className="mobile-app-section-wrapper-psp">
          <img src={AppPreviewImg} alt="mobile app preview" />
          <div className="mobile-app-right-section-wrapper">
            <span>Download Cordelia Xperience App</span>
            <span>
              Our App enables users to effortlessly oversee every aspect of their booking, from cabin selection to
              itinerary updates, ensuring a seamless and convenient experience right at your fingertips
            </span>
            <form className="mobile-number-input-wrapper" onSubmit={handleSendSms}>
              <input type="number" onChange={handleInputChange} value={number} placeholder="Mobile Number" />
              <button>Get App</button>
            </form>
            <div className="mobile-app-store-btn-wrapper">
              <a href="https://play.google.com/store/apps/details?id=com.cordeliacruises.userapp&hl=en_IN&pli=1">
                <img src={PlayStoreLogo} alt="play store logo" />
              </a>
              <a href="https://apps.apple.com/in/app/cordelia-cruises/id1589910857">
                <img src={AppleAppStoreLogo} alt="apple store logo" />
              </a>
            </div>
          </div>
        </div>
        <div className="small-mobile-app-section-wrapper-psp">
          <div className='image-wrapper'><img src={AppPreviewImg} alt="mobile app preview" /></div>
          <span>Download Cordelia Xperience App</span>
          <span>
            Our App enables users to effortlessly oversee every aspect of their booking, <br /> from cabin selection to
            itinerary updates, ensuring a seamless <br /> and convenient experience right at your fingertips
          </span>
          <form className="mobile-number-input-wrapper" onSubmit={handleSendSms}>
            <input type="number" onChange={handleInputChange} value={number} placeholder="Mobile Number" />
            <button type='submit'>Get App</button>
          </form>
          <div className="mobile-app-store-btn-wrapper">
            <a href="https://play.google.com/store/apps/details?id=com.cordeliacruises.userapp&hl=en_IN&pli=1">
              <img src={PlayStoreLogo} alt="play store logo" />
            </a>
            <a href="https://apps.apple.com/in/app/cordelia-cruises/id1589910857">
              <img src={AppleAppStoreLogo} alt="apple store logo" />
            </a>
          </div>
        </div>
      </>
    );
}

export default MobileAppSectionPSP;